<template>
    <div class="tw-animate-pulse tw-flex tw-justify-between tw-items-center tw-mb-4">
        <!-- Left Section Placeholder -->
        <div class="tw-flex tw-items-center">
            <!-- Image Placeholder -->
            <div
                class="tw-rounded-full tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-w-20 tw-h-20 tw-mr-[10px]">
            </div>
            <!-- Text Placeholder -->
            <div>
                <div class="tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-h-6 tw-w-32 tw-rounded-[40px] tw-mb-2"></div>
                <div class="tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-h-4 tw-w-24 tw-rounded-[40px]"></div>
            </div>
        </div>
        <!-- Right Section Placeholder -->
        <div class="tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-h-4 tw-w-8 tw-rounded-[40px]"></div>
    </div>
</template>
